module.exports = __webpack_public_path__ + "static/media/settings.ec2e255d.svg";